<template lang="pug">

#landscape-warning(v-if="isMobile")
  .icon
    img(src="~assets/landscape/icon.png")

  h1 {{ $t('landscape') }}

</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'landscape-warning',
  data: ()=> {
    return {

    }
  },
  computed: {
    ...mapState('browser', ['isMobile'])
  },
  mounted: function() {

  }
}
</script>

<style lang="sass" scoped>
@import "src/common.sass"

#landscape-warning
  +full()
  +user-select(none)
  +flex-center()
  background-color: $cl-red
  background-image: url('~assets/landscape/bg.gif')
  background-size: cover
  background-position: center
  color: white
  text-align: center
  pointer-events: none
  display: none

  @media screen and (min-aspect-ratio: 13/9)
    display: block !important
    display: flex !important
    pointer-events: all
    z-index: 1000

  .icon
    margin-bottom: 1rem

    img
      height: 24vh

  h1
    white-space: pre-line
    font-style: italic
    font-size: 1.5rem

</style>






// WEBPACK FOOTER //
// LandscapeWarning.vue?e8fa70d6